import React from 'react'
import i18n from 'i18n'

import AnalyticsMonitor from 'common/services/AnalyticsMonitor'

import { EDUCATION_GROUP_ID } from 'common/constants/ProductConstants'

export const TABS_ENUM = {
    WHY_INTERACTY_TAB: 1,
    BASICS_TAB: 2,
    WHAT_IS_NEXT_TAB: 3,
}

export const TABS = {
    [TABS_ENUM.WHY_INTERACTY_TAB]: {
        title: <>🖐&nbsp;&nbsp;{i18n.t('What is Interacty')}</>,
        onRead: () => {
            AnalyticsMonitor.track('Read onboarding', { group: EDUCATION_GROUP_ID, step: 1 })
        },
    },
    [TABS_ENUM.BASICS_TAB]: {
        title: <>🎓&nbsp;&nbsp;{i18n.t('Basics')}</>,
        onRead: () => {
            AnalyticsMonitor.track('Read onboarding', { group: EDUCATION_GROUP_ID, step: 2 })
        },
    },
    [TABS_ENUM.WHAT_IS_NEXT_TAB]: {
        title: <>🙌&nbsp;&nbsp;{i18n.t('What is next')}</>,
        onRead: () => {
            AnalyticsMonitor.track('Read onboarding', { group: EDUCATION_GROUP_ID, step: 3 })
        },
    },
}
